import PageHeader from "../common/pageHeader/v1";
import BlogList from "../components/section/blog/blogList/BlogList";

const Blogs = () => {
  return (
    <>
      <PageHeader />
      <BlogList />
    </>
  );
};

export default Blogs;
